var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderOrderMain',{attrs:{"header":"แก้ไขใบคืนสินค้า (Modify return slip)","img_header":_vm.img_holder,"link_back":"ordermain/returnsliplist"}}),_c('Return_slip_edit')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }